import React, { useState } from 'react';
import '../../../App.css';
import { ThemeProvider, useTheme } from '../../../theme/ThemeContext';

import {
  Container,
  Tab,
  Tabs
} from '@mui/material';

function AdminPage() {
  const [tabValue, setTabValue] = useState<number>(0);

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
  };

  return (
    <ThemeProvider>
      <div className="App">
        <Container>
          <h1>Admin</h1>
          <Container sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <Tabs value={tabValue} onChange={handleTabChange}>
            </Tabs>
          </Container>
          <Container>
          </Container>
        </Container>
      </div>
    </ThemeProvider>

  );
}

export default AdminPage;
